import React from 'react'

import classNames from './ChannelMenuItem.css'

export default function ChannelMenuItem ({ channel }) {
  return (
    <span>
      {channel.name}
      {channel.data && channel.data._state === 'present' &&
        <span className={classNames.info}>
          {channel.data.name}
        </span>
      }
      {channel.data && channel.data.schedule_start_time && channel.data.schedule_end_time &&
        <span className={classNames.info}>
          {!channel.data.schedule_end_time &&
            'Starts '
          }
          {channel.data.schedule_start_time}
          {channel.data.schedule_end_time &&
            ' - ' + channel.data.schedule_end_time
          }
        </span>
      }
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/present/ChannelMenuItem.js